import { Injectable } from "@angular/core";
import { ApiService } from "../api/api.service";
import { Observable } from "rxjs";
import { Ranking } from "../../interfaces/ranking";
import { RankingCriteria } from "../../models/ranking-criteria";
import { RankingScope } from "../../interfaces/ranking-scope";
import { Streak } from "../../interfaces/streak";
import { HttpContextBuilder } from "../../http/context/builders/http-context-builder.service";

@Injectable({
  providedIn: "root",
})
export class RankingService {
  constructor(
    private readonly apiService: ApiService,
    private readonly contextBuilder: HttpContextBuilder,
  ) {}

  getRanking(
    criteria: RankingCriteria,
    silent: boolean = false,
  ): Observable<Ranking> {
    const context = silent
      ? this.contextBuilder.skipErrorMessage().build()
      : this.contextBuilder.build();

    return this.apiService.getRequest<Ranking>(`ranking2/aggregated/`, {
      params: this.apiService.cleanPayload<RankingCriteria>(criteria),
      context,
    });
  }

  getScopes(): Observable<Array<RankingScope>> {
    return this.apiService.getRequest<Array<RankingScope>>("ranking2/scopes/");
  }

  getStreak(): Observable<Streak> {
    const context = this.contextBuilder.skipErrorMessage().build();

    return this.apiService.getRequest<Streak>("ranking2/streak/", {
      context,
    });
  }
}
